import React from 'react'
import { Box } from 'rebass'
import styled from 'styled-components'

const Paragraph = styled(Box)``

const P = ({ bold, ...props }) => <Paragraph {...props} mb={4} />

export default P
